import { HERO } from '@namespace/top/hero'
import { MOVIE_LINE } from '@namespace/top/movie_line'

export default function top() {
  window.addEventListener('load', () => {
    HERO.init()
    MOVIE_LINE.init()
  })
}
